import './styles.scss'
import { Link } from 'react-router-dom'
import { useEffect } from 'react'
const levels = [
  {
    amount: '$250,000+',
    label: 'Dedicate a majestic, old-growth redwood grove in one of California’s iconic forests. A sign bearing the grove name may be placed in the grove along a park trail or road.'
  },
  {
    amount: '$100,000+',
    label: 'Dedicate an accessible grove located along a park trail or road with a grove sign.',
  },
  {
    amount: '$50,000+',
    label: 'Dedicate a grove along a park trail or road in a mature second-growth redwood forest, with no grove sign.',
  },
  {
    amount: '$35,000+',
    label: 'Dedicate a wilderness grove in the quiet and deep reaches of the forest. These off-trail groves are perfect for making a beautiful, symbolic tribute.',
  },
  {
    amount: '$25,000+',
    label: 'Dedicate a restoration grove in a young, recovering redwood forest and help create the forest of future generations.',
  },
]

const ways = [
  {
    amount: '1',
    label: 'Make your gift today',
  },
  {
    amount: '2',
    label: 'Make a pledge to give over a period of one to five years (for gifts of $25,000+).',
  },
  {
    amount: '3',
    label: <>
      Designate Save the Redwoods League in your *will or trust.
      <br />
      *With this option, the grove or tree will be dedicated upon gift distribution. Our staff will work closely with your family, executors or trustees to find a place in the forest to honor your gift.
    </>
  },
]

export default function DedicateAGrove(props) {
  useEffect(() => {
    window.document.body.classList.remove('hideTitle')
  }, [])

  return (
    <div className='DedicateAGrove'>
      <div className='copy'>
        <h1>Dedicate A redwood Grove</h1>
        <h2>Make a unique tribute gift — dedicate a special place in the redwoods in honor of your loved ones</h2>
        <p>
          A tribute that lasts as long as the redwoods.
        </p>
        <p>
          Remember the moment you first looked up at a redwood tree and felt in awe of nature? Keep that feeling (and your memories) alive for millennia.
        </p>
        <p>
          Whether you are looking to honor your own connection to the redwoods or that of a loved one, your generous gift will protect the redwood forest for generations to come.
        </p>
        <ul>
          <li>
            Gifts of $250,000 or more to Save the Redwoods League may be recognized with a grove sign in an old-growth redwood grove.
          </li>
          <li>
            Gifts of $100,000 or more may be recognized with a grove sign in a beautiful second-growth redwood forest.
          </li>
          <li>
            Named groves can also be dedicated in restored forests or in the wilder reaches of the redwood forest.
          </li>
        </ul>
        <h2 style={{ marginTop: '2em'}}>How to Get Started</h2>
        <p>
          Please contact Jackie Perkins at (415) 820-5847 or email <a href="mailto:jperkins@SaveTheRedwoods.org">jperkins@SaveTheRedwoods.org</a> for more information and to arrange your site visit.
        </p>
      </div>
      <div className='howTo'>
        <h3>Dedicate level</h3>
        {levels.map((level, index) => (
          <div key={index} className='level'>
            <div className='amount'>{level.amount}</div>
            <div className='label'>{level.label}</div>
          </div>
        ))}
        <p>You can view the complete list of others who have <Link to='/find-a-grove'>dedicated groves</Link> over the decades.</p>
        <h3 style={{ marginTop: '2em'}}>Ways to Make a Gift</h3>
        {ways.map((level, index) => (
          <div key={index} className='level'>
            <div className='amount'>{level.amount}</div>
            <div className='label'>{level.label}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
